import React, { useEffect, useState } from "react"
import BasicTableComponent, { NumberRangeColumnFilter, SelectColumnFilter, DateRangeColumnFilter, formatDateTime } from "../../components/basic.table"
import { fetchAndSetData } from "../../api/Axios"

// Describes the current state of a punishment. LiteBans keeps a lifted punishment on its original
// row instead of adding a separate "Unban" entry, so the state has to be derived from several fields.
function describeState(punishment) {
    if (punishment.removedByName) {
        return "Aufgehoben"
    }
    // A kick happens once and has no state beyond that. A warning does, because LiteBans expires
    // warnings when "warnings.expire_after" is configured.
    if (punishment.category === "kick") {
        return "Erteilt"
    }
    if (punishment.expired) {
        return "Abgelaufen"
    }
    return punishment.active ? "Aktiv" : "Inaktiv"
}

// Collects the flags that are worth seeing at a glance. Kept as one column so the table stays
// readable instead of gaining a separate yes/no column per flag.
function describeNotes(punishment) {
    const notes = []
    if (punishment.ipBan) {
        notes.push("IP-Bann")
    }
    if (punishment.silent) {
        notes.push("Still")
    }
    // Only warnings track whether the player has seen the entry.
    if (punishment.category === "warning" && !punishment.warned) {
        notes.push("Ungesehen")
    }
    return notes.join(", ")
}

const PunishmentList = ({filter}) => {
    const columns =  [{
        Header: "Id",
        accessor: "id",
        Filter: NumberRangeColumnFilter,
        filter: 'between',
    }, {
        Header: "Typ",
        accessor: "type",
        Filter: SelectColumnFilter,
        filter: 'includes',
    }, {
        Header: "Status",
        accessor: (row, _) => describeState(row),
        Filter: SelectColumnFilter,
        filter: 'includes',
    }, {
        Header: "Erstellt",
        accessor: (row, _) => row.created * 1000,
        Cell: ({ value }) => formatDateTime(value),
        Filter: DateRangeColumnFilter,
        filter: 'dateBetween',
    }, {
        Header: "Ersteller",
        accessor: "creatorName"
    }, {
        Header: "Spieler",
        accessor: "punishedName"
    }, {
        Header: "Grund",
        accessor: "reason"
    }, {
        Header: "Zeit",
        accessor: "time"
    }, {
        Header: "Läuft ab",
        // Permanent punishments have no expiry date, and neither do kicks and warnings.
        accessor: (row, _) => row.until === 0 ? "" : row.until * 1000,
        Cell: ({ value }) => formatDateTime(value),
        Filter: DateRangeColumnFilter,
        filter: 'dateBetween',
    }, {
        Header: "Aufgehoben von",
        accessor: "removedByName"
    }, {
        Header: "Grund der Aufhebung",
        accessor: "removedByReason"
    }, {
        Header: "Hinweise",
        accessor: (row, _) => describeNotes(row),
        Filter: SelectColumnFilter,
        filter: 'includes',
    }, {
        Header: "Server",
        accessor: "serverOrigin",
        Filter: SelectColumnFilter,
        filter: 'includes',
    }]

    const [punishments, setPunishments] = useState([])
    useEffect(() => {
        fetchAndSetData("/api/punishments" + (filter === undefined ? "" : "/" + filter), "Verwarnungen konnten nicht geladen werden.", setPunishments)
    }, [filter])

    return (
        <div>
            <BasicTableComponent columns={columns} data={punishments} editUrlPart="punishment" />
        </div>
    )
}

export default PunishmentList
